import loadable from "@loadable/component";

const Technology = loadable(() => import("./Technology.page"));

export default { component: Technology };
